import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ChipInput from '../../ChipInput/ChipInput';
import { useUser } from '../../../hooks/use-user';

function CompanySelect({ selected, setSelected }) {
	const { t } = useTranslation();
	const { activeCompany } = useUser();

	const [options, setOptions] = useState([]);
	const [companiesAvailableForSharing, setCompaniesAvailableForSharing] = useState(null);

	useEffect(() => {
		setCompaniesAvailableForSharing(activeCompany?.sharedCompanies);
	}, []);

	useEffect(() => {
		if (companiesAvailableForSharing) {
			setOptions(
				companiesAvailableForSharing.map((company) => ({ label: company.name, value: company.id })),
			);
		}
	}, [companiesAvailableForSharing]);

	return selected.length || options.length ? (
		<dl className="mt-3">
			<dt className="mb-1 text-primary-color">{t('reservations.selectCompaniesToShare')}</dt>
			<ChipInput
				options={options}
				setSelected={setSelected}
				selected={selected}
				title={t('reservations.selectedCompanies')}
			/>
		</dl>
	) : null;
}

export default CompanySelect;
